angular.module('forms').controller('PatientQuestionnaireCtrl',
    ['$scope', '$timeout', '$stateParams', 'toaster', 'aprgettext', 'PatientPortalStorageRepository', 'FormsRepository', 'FormsService', 'TransitionManager', 'FormsId',
        function ($scope, $timeout, $stateParams, toaster, gettext, PatientPortalStorageRepository, FormsRepository, FormsService, TransitionManager, FormsId) {
            'use strict';

            $scope.hxQuestion = {
                isPatientHxQuestion: false,
                isPatientProblemDiagnosisHxQuestion: false,
                isFamilyProblemHxQuestion: false,
                isImmunizationHxQuestion: false
            };

            $scope.savingQuestionnaire = false;
            $scope.loadingSection = { loading: false};
            $scope.patientQuestionnaire = null;

            // TODO : Move section navigation into a custom directive ???
            $scope.navigationSectionParams = {
                currentSectionNumber: 0,
                currentSectionName: '',
                nextSectionName: '',
                firstSectionNumber: 0,
                lastSectionNumber: 0,
                maxNavigationItems: 5
            };


            function loadPage() {
                $scope.loadingSection.loading = true;
                $scope.removeHttpError();

                FormsService.removeLocalStorageKeys('subfindtableitems');


                FormsRepository
                .getPatientQuestionnaire(PatientPortalStorageRepository.getActivePatient().id, $stateParams.relSurveyPatientId)
                .then(function (data) {
                    $scope.patientQuestionnaire = data;
                    //console.log($scope.patientQuestionnaire);

                    if ($scope.patientQuestionnaire && $scope.patientQuestionnaire.Questionnaire && $scope.patientQuestionnaire.Questionnaire.Sections) {
                        initializeSectionNavigation();
                        var containsPatientHxQuestion = $scope.patientQuestionnaire.Questionnaire.Sections[$scope.navigationSectionParams.currentSectionNumber - 1].ContainsPatientHxQuestion;
                        $scope.loadingSection.loading = !containsPatientHxQuestion;
                    } else {
                        $scope.loadingSection.loading = false;
                    }
                })
                .catch(function (response) {
                    $scope.addHttpError(response);
                    $scope.loadingSection.loading = false;
                });
            }
            loadPage();


            function initializeSectionNavigation() {
                _.forEach($scope.patientQuestionnaire.Questionnaire.Sections, function(section) {
                    section.Visible = section.SectionNumber <= $scope.navigationSectionParams.maxNavigationItems;

                    _.forEach(section.Questions, function(question) {
                        question.RequiredFieldsPopulated = true;
                    });
                });

                $scope.navigationSectionParams.currentSectionNumber = 1;
                $scope.navigationSectionParams.currentSectionName = $scope.patientQuestionnaire.Questionnaire.Sections[0].SurveySectionName;
                $scope.navigationSectionParams.firstSectionNumber = 1;

                if ($scope.patientQuestionnaire.Questionnaire.Sections.length > $scope.navigationSectionParams.maxNavigationItems) {
                    $scope.navigationSectionParams.lastSectionNumber = $scope.navigationSectionParams.maxNavigationItems;
                } else {
                    $scope.navigationSectionParams.lastSectionNumber = $scope.patientQuestionnaire.Questionnaire.Sections.length;
                }

                $scope.navigationSectionParams.nextSectionName = getNextSectionName();
            }


            function getNextSectionName() {
                // Sections collection is zero based.  Section Number is 1 based.
                if ($scope.navigationSectionParams.currentSectionNumber < $scope.patientQuestionnaire.Questionnaire.Sections.length) {
                    return $scope.patientQuestionnaire.Questionnaire.Sections[$scope.navigationSectionParams.currentSectionNumber].SurveySectionName;
                }
                else {
                    return 'Submit Form';
                }
            }


            function getCurrentSectionName() {
                // Sections collection is zero based.  Section Number is 1 based.
                if ($scope.navigationSectionParams.currentSectionNumber > 0) {
                    return $scope.patientQuestionnaire.Questionnaire.Sections[$scope.navigationSectionParams.currentSectionNumber - 1].SurveySectionName;
                }
            }


            function validateCheckboxQuestions() {
                var curQuestions = $scope.patientQuestionnaire.Questionnaire.Sections[$scope.navigationSectionParams.currentSectionNumber - 1].Questions;
                var curCheckboxQuestions = _.filter(curQuestions, function(question) {
                    return question.QuestionEnabled === true && question.SurveyControlTypeName.toUpperCase() === 'CHECKBOX';
                });
                if (curCheckboxQuestions && curCheckboxQuestions.length > 0) {
                    var checkboxQuestionsHaveAnswers = true;

                    _.forEach(curCheckboxQuestions, function(checkboxQuestion) {
                        if (checkboxQuestion.QuestionEnabled && checkboxQuestion.QuestionRequireAnswer) {
                            var selectedAnswer = _.find(checkboxQuestion.Answers, function(answer) {
                                return answer.SelectedAnswer === true;
                            });
                            if (!selectedAnswer) {
                                checkboxQuestion.RequiredFieldsPopulated = false;
                                checkboxQuestionsHaveAnswers = false;
                            }
                        }
                    });

                    if (!checkboxQuestionsHaveAnswers) {
                        $scope.patientQuestionnaireForm.$valid = false;
                        $scope.patientQuestionnaireForm.$invalid = true;
                        return;
                    }
                }
            }


            $scope.submitQuestionnaire = function submitQuestionnaire(finishLater) {
                $scope.savingQuestionnaire = true;

                // For each History Section, remove Problem History Answer items that are not selected.
                // This is will eliminate unneeded items from the respective collections.
                var patientHistorySections = _.filter($scope.patientQuestionnaire.Questionnaire.Sections, {ContainsPatientHxQuestion: true});
                if (patientHistorySections) {
                    var unselectedItems = [];

                    _.forEach(patientHistorySections, function(historySection) {
                       if (historySection.HistoryGroupId.toUpperCase() === FormsId.HistoryGroupId.ProblemDiagnosis)  {
                           unselectedItems = _.filter(historySection.ProblemHistoryAnswers, {Selected: false});
                           _.forEach(unselectedItems, function(removeObj) {
                               _.pull(historySection.ProblemHistoryAnswers, removeObj);
                           });
                       } else if (historySection.HistoryGroupId.toUpperCase() === FormsId.HistoryGroupId.Family) {
                           _.forEach(historySection.FamilyHistoryAnswers, function(familyHxAnswer) {
                               unselectedItems = _.filter(familyHxAnswer.ProblemHistoryAnswers, {Selected: false});
                               _.forEach(unselectedItems, function(removeObj) {
                                   _.pull(familyHxAnswer.ProblemHistoryAnswers, removeObj);
                               });
                           });
                       } else if (historySection.HistoryGroupId.toUpperCase() === FormsId.HistoryGroupId.Immunization) {
                           if (historySection.ImmunizationHistoryAnswers.ImmunizationAdultAnswers && historySection.ImmunizationHistoryAnswers.ImmunizationAdultAnswers.length > 0) {
                               unselectedItems = _.filter(historySection.ImmunizationHistoryAnswers.ImmunizationAdultAnswers[0].ImmunizationAnswers, {Selected: false});
                               _.forEach(unselectedItems, function(removeObj) {
                                   _.pull(historySection.ImmunizationHistoryAnswers.ImmunizationAdultAnswers[0].ImmunizationAnswers, removeObj);
                               });
                           }

                           if (historySection.ImmunizationHistoryAnswers.ImmunizationPediatricAnswers && historySection.ImmunizationHistoryAnswers.ImmunizationPediatricAnswers.length > 0) {
                               unselectedItems = _.filter(historySection.ImmunizationHistoryAnswers.ImmunizationPediatricAnswers[0].ImmunizationAnswers, {Selected: false});
                               _.forEach(unselectedItems, function(removeObj) {
                                   _.pull(historySection.ImmunizationHistoryAnswers.ImmunizationPediatricAnswers[0].ImmunizationAnswers, removeObj);
                               });
                           }
                       }
                    });
                }

                if (finishLater === 'FINISH-LATER')  {
                    $scope.patientQuestionnaire.Completed = false;
                } else {
                    $scope.patientQuestionnaire.Completed = true;
                }

                FormsRepository.putPatientQuestionnaire($scope.patientQuestionnaire)
                    .then(function () {
                        if ($scope.patientQuestionnaire.Completed)  {
                            var completedForm = {
                                Form: { Id: $scope.patientQuestionnaire.RelSurveyPatientId, Name: $scope.patientQuestionnaire.Questionnaire.SurveyName},
                                Patient: { Id: $scope.patientQuestionnaire.PatientId}
                            };

                            FormsService.cacheCompletedForm(completedForm);
                            TransitionManager.transition({appRoute: 'confirmForm'});
                        } else {
                            toaster.pop('success', '', gettext('Your questionnaire answers have been saved and can be completed later.'));
                            TransitionManager.transition({appRoute: 'forms'});
                        }
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('The patient form was not saved.  Please try again or contact your practice for further assistance.'));
                    })
                    .finally(function () {
                        $scope.savingQuestionnaire = false;
                    });
            };


            $scope.navMoveNext = function navMoveNext() {
                $scope.patientQuestionnaireForm.isSubmitted = true;
                validateCheckboxQuestions();

                if (!$scope.patientQuestionnaireForm.$valid) {
                    return;
                }

                $scope.patientQuestionnaireForm.isSubmitted = false;

                var curSectionNumber = $scope.navigationSectionParams.currentSectionNumber;
                var numOfSections = $scope.patientQuestionnaire.Questionnaire.Sections.length;

                if (curSectionNumber ===  numOfSections) {
                    return $scope.submitQuestionnaire();
                }

                if ((curSectionNumber > 0) && (curSectionNumber < numOfSections)) {
                    $scope.loadingSection.loading = true;

                    $timeout(function() {
                        $scope.navigationSectionParams.currentSectionNumber = ++curSectionNumber;
                        $scope.navigationSectionParams.currentSectionName = getCurrentSectionName();

                        if (curSectionNumber > $scope.navigationSectionParams.lastSectionNumber)
                        {
                            $scope.navigationSectionParams.firstSectionNumber++;
                            $scope.navigationSectionParams.lastSectionNumber++;
                            _.forEach($scope.patientQuestionnaire.Questionnaire.Sections, function (section) {
                                if ((section.SectionNumber >= $scope.navigationSectionParams.firstSectionNumber) &&
                                    (section.SectionNumber <= $scope.navigationSectionParams.lastSectionNumber))  {
                                    section.Visible = true;
                                }
                                else {
                                    section.Visible = false;
                                }
                            });
                        }

                        $scope.navigationSectionParams.nextSectionName = getNextSectionName();
                    }, 0, true);
                }
            };


            $scope.navMovePrevious = function navMovePrevious() {
                // Should always be able to move back to the previous section, even if current section is not valid.
/*
                $scope.patientQuestionnaireForm.isSubmitted = true;
                if (!$scope.patientQuestionnaireForm.$valid) {
                    return;
                }
*/

                $scope.patientQuestionnaireForm.isSubmitted = false;

                var curSectionNumber = $scope.navigationSectionParams.currentSectionNumber;

                if (curSectionNumber > 1) {
                    $scope.loadingSection.loading = true;

                    $timeout(function() {
                        $scope.navigationSectionParams.currentSectionNumber = --curSectionNumber;
                        $scope.navigationSectionParams.currentSectionName = getCurrentSectionName();

                        if (curSectionNumber < $scope.navigationSectionParams.firstSectionNumber) {
                            $scope.navigationSectionParams.firstSectionNumber--;
                            $scope.navigationSectionParams.lastSectionNumber--;
                            _.forEach($scope.patientQuestionnaire.Questionnaire.Sections, function (section) {
                                if ((section.SectionNumber >= $scope.navigationSectionParams.firstSectionNumber) &&
                                    (section.SectionNumber <= $scope.navigationSectionParams.lastSectionNumber))  {
                                    section.Visible = true;
                                }
                                else {
                                    section.Visible = false;
                                }
                            });
                        }

                        $scope.navigationSectionParams.nextSectionName = getNextSectionName();
                    }, 0, true);
                }
            };


            $scope.displaySection = function displaySection(section) {
                var curSectionNumber = $scope.navigationSectionParams.currentSectionNumber;

                if (section.SectionNumber === curSectionNumber) {
                    // User is wanting to page to current section
                    $scope.patientQuestionnaireForm.isSubmitted = false;
                    return;
                }

/*
                if (section.SectionNumber > curSectionNumber) {
                    // Cannot skip ahead
                    return;
                }
*/

                validateCheckboxQuestions();

                if ((section.SectionNumber < curSectionNumber) || ($scope.patientQuestionnaireForm.$valid)) {
                    // User is wanting to page to a previous section or form is valid.  Page to respective section.
                    $scope.patientQuestionnaireForm.isSubmitted = false;
                    $scope.loadingSection.loading = true;

                    $timeout(function() {
                        $scope.navigationSectionParams.currentSectionNumber = section.SectionNumber;
                        $scope.navigationSectionParams.currentSectionName = getCurrentSectionName();
                        $scope.navigationSectionParams.nextSectionName = getNextSectionName();
                    }, 0, true);
                    return;
                }

                // User is wanting to page to next section and view is not valid
                $scope.patientQuestionnaireForm.isSubmitted = true;
            };

        }]);